import { Box, TextField, Typography } from '@mui/material'

const CustomInput = ({
    label,
    value,
    onChange,
    placeholder = '',
    required = false,
    error = false,
    helperText = '',
    disabled = false,
    type = 'text',
    multiline = false,
    fullWidth = false,
    rows = 1,
    maxLength,
    ...props
}) => {
    return (
    <Box sx={{ minWidth: fullWidth ? 'auto' : 225, flex: fullWidth ? 1 : '0 0 auto', width: fullWidth ? '100%' : 'auto' }}>
            {label && (
                <Typography
                    sx={{
                        fontSize: '16px',
                        fontWeight: 500,
                        color: 'var(--forbrand-primary)',
                        mb: 1,
                        lineHeight: '140%'
                    }}
                >
                    {label}
                    {required && <span style={{ color: 'var(--forbrand-error)' }}>*</span>}
                </Typography>
            )}
            <TextField
                fullWidth
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                error={error}
                helperText={helperText}
                disabled={disabled}
                type={type}
                multiline={multiline}
                rows={rows}
                variant="outlined"
                size="medium"
                sx={{
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: disabled ? 'var(--bg-disabled)' : '#fff',
                        fontSize: '14px',
                        height: multiline ? 'auto' : '48px',
                        borderRadius: 'unset',
                        '& fieldset': {
                            borderColor: error ? 'var(--forbrand-error)' : 'var(--forbrand-primary)',
                        },
                        '&:hover fieldset': {
                            borderColor: error ? 'var(--forbrand-error)' : 'var(--forbrand-primary)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: error ? 'var(--forbrand-error)' : 'var(--forbrand-color)',
                        },
                        '&.Mui-disabled': {
                            backgroundColor: 'var(--bg-disabled)',
                        },
                    },
                    '& .MuiInputBase-input::placeholder': {
                        color: '#999',
                        opacity: 1,
                    },
                    ...(type === 'number' && {
                        '& .MuiInputBase-input': {
                            MozAppearance: 'textfield',
                            '&::-webkit-outer-spin-button': {
                                WebkitAppearance: 'none',
                                margin: 0,
                            },
                            '&::-webkit-inner-spin-button': {
                                WebkitAppearance: 'none',
                                margin: 0,
                            },
                        },
                    }),
                }}
                slotProps={{
                    formHelperText: {
                        sx: { margin: 0, mt: 0.5 },
                    },
                    htmlInput: maxLength ? { maxLength } : undefined,
                }}
                {...props}
            />
        </Box>
    )
}

export default CustomInput
